import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks';
import { TickIcon } from '../../../../ui/icons/TickIcon';
import { CustomAccordion } from '../../../../ui/molecules/accordion';
import Button from '../../../../ui/molecules/button';
import { ButtonComponent } from '../../../../ui/molecules/button/newButton';
import { MadfarmInput } from '../../../../ui/molecules/input/newInput';
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch';
import { MultiProtocolSearch } from '../../../../ui/molecules/ProtocolSearch/multisearch';
import { ProtocolSelectByAttachment } from '../../../../ui/molecules/ProtocolSelectByAtt';
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj';
import { CustomRadio } from '../../../../ui/molecules/radioButton';
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static';
import { SingleCheckbox } from '../../../../ui/molecules/SingleCheckbox';
import TextArea from '../../../../ui/molecules/textArea';
import { Alert } from '../../../../ui/organisms/alert';
import { optionsFormatter, OptionType, ReportingStatusOption, ReportingTypologyOption } from '../../../../utils';
import { GetAllReportings, resetGetAllReportingsStatus } from '../../../gestioneControllo/segnalazioni/slice';
import { MeasureVersionEnum } from '../../../gestioneProvvedimenti/measures/dataService/dto';
import { CompilationStateDTO, RequestStateDTO } from '../dataService/dto';
import { DownloadRidDocx, GetRIDBYId, resetRIDDeleteStatus, resetStateUpdateStatus, RIDDelete, RIDUpdateState, setUpdateRIDCertificateRequestProtocolId, setUpdateRIDClosedNote, setUpdateRIDClosingProtocolIds, setUpdateRIDDeadlineRequestedDocument, setUpdateRIDDepartureProtocolId, setUpdateRIDDocumentalControlProtocolId, setUpdateRIDNewMeasureId, setUpdateRIDNote, setUpdateRIDObject, setUpdateRIDOldMeasureId, setUpdateRIDOther, setUpdateRIDReportingId } from '../slice';
import '../styles.scss';

export function EditRIDForms() {
    const dispatch = useAppDispatch()
    const ridState = useAppSelector(state => state.rid)
    const userState = useAppSelector(state => state.users)
    const sessionState = useAppSelector(state => state.session)
    const reportingState = useAppSelector(state => state.reporting)
    const newMeasureState = useAppSelector(state => state.newMeasure)

    const navigate = useNavigate()

    const [expanded, setExpanded] = useState<string | false>("panel1");
    const [measureVersionSelection, setMeasureVersionSelection] = useState<MeasureVersionEnum | null>(null)
    const [notificationFlag, setNotificationFlag] = useState<boolean>(false)
    const [entryClient, setEntryClient] = useState<boolean>(false)
    const [inspectionControl, setInspectionControl] = useState<boolean>(false)
    const [documentControl, setDocumentControl] = useState<boolean>(false)
    const [certificationRequest, setCertificationRequest] = useState<boolean>(false)
    const [reportFlag, setReportFlag] = useState<boolean>(false)
    const [otherFlag, setOtherFlag] = useState<boolean>(false)
    const [closeFlag, setCloseFlag] = useState<string | undefined>(undefined)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [reportings, setReportings] = useState<OptionType[]>([])

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => (prev === panel ? false : panel))
    }

    const compilationPredicate = (): boolean => {

        return ridState.getRidByIdResponse?.attachmentIds?.length! > 0 &&
            ridState.getRidByIdResponse?.departureProtocolId !== undefined &&
            ridState.getRidByIdResponse?.deadlineRequestedDocument !== undefined &&
            ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.IN_CORSO &&
            ridState.getRidByIdResponse?.isMotivation
    }

    useEffect(() => {
        if (ridState.ridStateUpdateStatus === 'successfully') {
            dispatch(resetStateUpdateStatus())
            dispatch(GetRIDBYId(ridState.getRidByIdResponse?.id!))
        }
    }, [ridState.ridStateUpdateStatus])

    useEffect(() => {
        if (ridState.ridDeleteStatus === 'successfully') {
            dispatch(resetRIDDeleteStatus())
            navigate('/rid')
        }
    }, [ridState.ridDeleteStatus])

    useEffect(() => {
        dispatch(GetAllReportings({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
    }, [])

    useEffect(() => {
        if (reportingState.getAllReportingsStatus === 'successfully' &&
            reportingState.getAllReportingsResponse !== undefined
        ) {
            dispatch(resetGetAllReportingsStatus())
            const data = reportingState.getAllReportingsResponse.data.map(rep => {
                return {
                    value: rep.id,
                    label: `${optionsFormatter(rep.reportingType, ReportingTypologyOption)} - ${optionsFormatter(rep.reportingState, ReportingStatusOption)}`
                } as OptionType
            })
            setReportings(data)
        }
    }, [reportingState.getAllReportingsStatus])

    useEffect(() => {
        dispatch(GetAllReportings({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
        setReportFlag(ridState.ridUpdateRequest.reportingId !== null)
        setCertificationRequest(ridState.ridUpdateRequest.certificateRequestProtocolId !== null)
        setDocumentControl(ridState.ridUpdateRequest.documentalControlProtocolId !== null)
        setOtherFlag(ridState.ridUpdateRequest.other !== null)
        if (ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA)
            setCloseFlag(ridState.ridUpdateRequest.closingProtocolIds !== null ? 'CLOSE' : 'OPEN')
        if (ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA) {
            if (ridState.ridUpdateRequest.closingProtocolIds === null)
                setMeasureVersionSelection(ridState.ridUpdateRequest.newMeasureId ? MeasureVersionEnum.NEW : MeasureVersionEnum.OLD)
        }
    }, [])

    return (
        <div className='flex flex-col gap-4'>
            <div style={{ flex: '0.5', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                {
                    userState.findMeResponse.role === 'admin' ? (
                        <ButtonComponent
                            iconPosition='off'
                            variant='solid'
                            color='red'
                            size='sm'
                            label='Elimina R.I.D.'
                            onClick={() => setShowAlert(true)}
                        />
                    ) : ridState.getRidByIdResponse?.requestState === RequestStateDTO.APERTA ? (
                        <ButtonComponent
                            iconPosition='off'
                            variant='outline'
                            color='red'
                            size='sm'
                            label='Elimina R.I.D.'
                            onClick={() => setShowAlert(true)}
                        />
                    ) : <></>
                }
                {
                    compilationPredicate() && (
                        <ButtonComponent
                            iconPosition='right'
                            icon={<TickIcon />}
                            variant='outline'
                            color='blue'
                            size='sm'
                            label='Compilazione completata'
                            onClick={() => dispatch(RIDUpdateState({ body: ridState.ridUpdateStateRequest, id: ridState.ridIdToUpdate }))}
                        />
                    )
                }
            </div>

            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Dati generali R.I.D.</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <ProtocolSelectByObject
                    customerId={sessionState.selected.customerId!}
                    objectId='77'
                    type='departure'
                    placeholder='Seleziona...'
                    title='Protocollo RID'
                    disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    defaultValue={ridState.ridUpdateRequest.departureProtocolId}
                    value={ridState.ridUpdateRequest.departureProtocolId}
                    onChange={(value) => dispatch(setUpdateRIDDepartureProtocolId(value))}
                />
                <MadfarmInput
                    label="Oggetto"
                    defaultValue='Richiesta integrazione documenti'
                    disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    onChangeText={(text) => dispatch(setUpdateRIDObject(text))}
                />
                <TextArea
                    label="Note aggiuntive"
                    disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    value={ridState.ridUpdateRequest.note}
                    onChangeText={(text) => dispatch(setUpdateRIDNote(text))}
                />
                <MadfarmInput
                    label="Scadenza invio documenti richiesti"
                    disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    value={ridState.ridUpdateRequest.deadlineRequestedDocument}
                    placeholder='Numero di giorni...'
                    onChangeText={(text) => dispatch(setUpdateRIDDeadlineRequestedDocument(text))}
                />
                <div className="text-left flex flex-row items-center gap-1">
                    <span className='text-text-sm font-medium text-neutral-600'>Funzionario che ha emesso la RID: </span>
                    <span className="text-text-sm font-bold text-brandPrimary-600">{ridState.getRidByIdResponse?.officerInfo}</span>
                </div>
            </CustomAccordion>
            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Motivazioni che hanno generato la R.I.D.</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={notificationFlag}
                            setChecked={(value) => {
                                setNotificationFlag(value)
                                // dispatch
                            }}
                            label=''
                        />
                    </div>
                    <MadfarmStaticSelect
                        noOptionsMessage=""
                        label="Notifica"
                        options={[{ label: 'Notifica 1', value: '1' }]}
                        placeholder='Seleziona notifica...'
                        disabled={!notificationFlag || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    />
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={entryClient}
                            setChecked={(value) => {
                                setEntryClient(value)
                                // dispatch
                            }}
                            label=''
                        />
                    </div>
                    <MadfarmStaticSelect
                        noOptionsMessage=""
                        label="Cliente in ingresso"
                        options={[{ label: 'Cliente 1', value: '1' }]}
                        placeholder='Seleziona cliente...'
                        disabled={!entryClient || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    />
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={inspectionControl}
                            setChecked={(value) => {
                                setInspectionControl(value)
                                // dispatch
                            }}
                            label=''
                        />
                    </div>
                    <MadfarmStaticSelect
                        noOptionsMessage=""
                        label="Controllo ispettivo"
                        options={[{ label: 'Controllo ispettivo 1', value: '1' }]}
                        placeholder='Seleziona controllo (visita ispettiva)...'
                        disabled={!inspectionControl || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    />
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={documentControl}
                            setChecked={(value) => {
                                setDocumentControl(value)
                                if (!value) {
                                    dispatch(setUpdateRIDDocumentalControlProtocolId(undefined))
                                }
                            }}
                            label=''
                        />
                    </div>
                    <div className='w-full'>
                        <ProtocolSearch
                            label="Controllo documentale"
                            type='entry'
                            disabled={!documentControl || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            defaultValue={ridState.ridUpdateRequest.documentalControlProtocolId}
                            onSelect={(value) => dispatch(setUpdateRIDDocumentalControlProtocolId(value))}
                        />
                    </div>
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={certificationRequest}
                            setChecked={(value) => {
                                setCertificationRequest(value)
                                if (!value) {
                                    dispatch(setUpdateRIDCertificateRequestProtocolId(undefined))
                                }
                            }}
                            label=''
                        />
                    </div>
                    <ProtocolSelectByAttachment
                        customerId={sessionState.selected.customerId!}
                        attachmentId='249'
                        type='entry'
                        placeholder='Seleziona protocollo entrata con Allegato “Richiesta Certificato”'
                        title='Richiesta certificato'
                        disabled={!certificationRequest || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                        defaultValue={ridState.ridUpdateRequest.certificateRequestProtocolId}
                        value={ridState.ridUpdateRequest.certificateRequestProtocolId}
                        onChange={(value) => dispatch(setUpdateRIDCertificateRequestProtocolId(value))}
                    />
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={reportFlag}
                            setChecked={(value) => {
                                setReportFlag(value)
                                if (!value) {
                                    dispatch(setUpdateRIDReportingId(undefined))
                                }
                            }}
                            label=''
                        />
                    </div>
                    <MadfarmStaticSelect
                        label="Segnalazione"
                        noOptionsMessage=""
                        options={reportings}
                        value={ridState.ridUpdateRequest.reportingId}
                        onChange={(value) => dispatch(setUpdateRIDReportingId(value))}
                        placeholder='Seleziona segnalazione...'
                        disabled={!reportFlag || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                    />
                </div>
                <div className='flex flex-row items-center gap-1'>
                    <div className='mt-4'>
                        <SingleCheckbox
                            disabled={ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                            checked={otherFlag}
                            setChecked={(value) => {
                                setOtherFlag(value)
                                if (!value) {
                                    dispatch(setUpdateRIDOther(undefined))
                                }
                            }}
                            label=''
                        />
                    </div>
                    <MadfarmInput
                        label="Altro"
                        disabled={!otherFlag || ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA}
                        value={ridState.ridUpdateRequest.other}
                        onChangeText={(text) => dispatch(setUpdateRIDOther(text))}
                    />
                </div>
            </CustomAccordion>
            {
                ridState.getRidByIdResponse?.compilationState === CompilationStateDTO.COMPLETATA && (
                    <CustomAccordion
                        id="panel3"
                        title={<span className="text-uppercase text-white label-input">Informazioni Stato di chiusura R.I.D.</span>}
                        expanded={expanded === 'panel3'}
                        onChange={() => handleToggleAccordion('panel3')}
                        detailsClassName="flex flex-col gap-6"
                    >
                        <div className="flex flex-col gap-2">
                            <span className="text-left text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                                Chiusa con i seguenti protocolli
                            </span>
                            <div className='flex flex-row items-center gap-1'>
                                <div className='mt-4'>
                                    <CustomRadio
                                        disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                        options={[{ label: '', value: 'CLOSE' }]}
                                        selectedValue={closeFlag}
                                        onChange={(value) => setCloseFlag(value)}
                                        id={'close'}
                                        name={'close'}
                                    />
                                </div>
                                <div className='w-full'>
                                    <MultiProtocolSearch
                                        disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                        type='entry'
                                        defaultValue={ridState.ridUpdateRequest.closingProtocolIds}
                                        onSelect={(value) => dispatch(setUpdateRIDClosingProtocolIds(value))}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <span className="text-left text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                                Non chiusa
                            </span>
                            <div className="flex flex-row items-center gap-2">
                                <CustomRadio
                                    disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                    options={[{ label: '', value: 'OPEN' }]}
                                    selectedValue={closeFlag}
                                    onChange={(value) => setCloseFlag(value)}
                                    id={'open'}
                                    name={'open'}
                                />
                                <span className='text-text-md font-bold text-brandPrimary-800'>Emissione Provvedimento</span>
                            </div>
                            {
                                closeFlag === 'OPEN' && (
                                    <div className="ml-8 flex flex-col gap-6 mt-4">
                                        <div className="flex flex-col gap-3">
                                            <div className="flex items-center gap-2">
                                                <CustomRadio
                                                    disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                                    options={[{ label: '', value: MeasureVersionEnum.NEW }]}
                                                    selectedValue={measureVersionSelection}
                                                    onChange={(value) => {
                                                        setMeasureVersionSelection(value as MeasureVersionEnum)
                                                        dispatch(setUpdateRIDOldMeasureId(undefined))
                                                    }}
                                                    id={'new_measure_closing'}
                                                    name={'new_measure_closing'}
                                                />
                                                <span className="font-semibold text-[16px]" style={{ color: '#5a8388' }}>
                                                    Seleziona Provvedimento (DM n.0323651 del 18/07/2024)
                                                </span>
                                            </div>

                                            <div className="ml-8 flex flex-row items-center gap-6">
                                                <div className="flex-1">
                                                    <MadfarmStaticSelect
                                                        label="Seleziona il provvedimento di riferimento"
                                                        value={ridState.ridUpdateRequest.newMeasureId}
                                                        disabled={measureVersionSelection === MeasureVersionEnum.OLD ||
                                                            ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA
                                                        }
                                                        placeholder={'Seleziona provvedimento...'}
                                                        options={newMeasureState.savedNewMeasures.map(sm => {
                                                            return { value: sm.id, label: sm.protocolInfo }
                                                        })}
                                                        onChange={(value) => {
                                                            //@ts-ignore
                                                            const newValue = value !== null ? value.value : null
                                                            dispatch(setUpdateRIDNewMeasureId(newValue))
                                                        }}
                                                        noOptionsMessage={''}
                                                    />
                                                </div>

                                                <div className="flex-1">
                                                    <div className="text-sm font-bold text-gray-600 mb-1">
                                                        Codice Riferimento Normativo Non Conformità
                                                    </div>
                                                    <div className="text-base text-gray-900">
                                                        {newMeasureState.savedNewMeasures.filter(nm => nm.id === ridState.ridUpdateRequest.newMeasureId)[0]?.ncCode.code || 'Codice non trovato'}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mb-1' style={{ display: 'flex', gap: '8px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <CustomRadio
                                                        disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                                        options={[{ label: '', value: MeasureVersionEnum.OLD }]}
                                                        selectedValue={measureVersionSelection}
                                                        onChange={(value) => {
                                                            setMeasureVersionSelection(value as MeasureVersionEnum)
                                                            dispatch(setUpdateRIDNewMeasureId(undefined))
                                                        }}
                                                        id={'old_measure_closing'}
                                                        name={'old_measure_closing'}
                                                    />
                                                </div>
                                                <div className='text-left'>
                                                    <span className='subtitle' style={{ color: '#5a8388' }}>Seleziona Provvedimento (DM n.15962 del 20/12/2013)</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col gap-3">
                                            <div className="flex items-center gap-2">
                                                <CustomRadio
                                                    disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                                    options={[{ label: '', value: MeasureVersionEnum.OLD }]}
                                                    selectedValue={measureVersionSelection}
                                                    onChange={(value) => {
                                                        setMeasureVersionSelection(value as MeasureVersionEnum);
                                                        dispatch(setUpdateRIDNewMeasureId(undefined));
                                                    }}
                                                    id="old_measure_closing"
                                                    name="old_measure_closing"
                                                />
                                                <span className="font-semibold text-[16px]" style={{ color: '#5a8388' }}>
                                                    Seleziona Provvedimento (DM n.15962 del 20/12/2013)
                                                </span>
                                            </div>
                                            <div className="ml-8 flex flex-row items-center gap-6">
                                                <div className="flex-1">
                                                    <MadfarmStaticSelect
                                                        noOptionsMessage=''
                                                        label="Seleziona il provvedimento di riferimento"
                                                        value={ridState.ridUpdateRequest.newMeasureId}
                                                        disabled={measureVersionSelection === MeasureVersionEnum.NEW ||
                                                            ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA
                                                        }
                                                        placeholder={'Seleziona provvedimento...'}
                                                        options={newMeasureState.savedOldMeasures.map(sm => {
                                                            return { value: sm.id, label: sm.protocolInfo }
                                                        })}
                                                        onChange={(value) => {
                                                            //@ts-ignore
                                                            const newValue = value !== null ? value.value : null
                                                            dispatch(setUpdateRIDOldMeasureId(value))
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex-1">
                                                    <div className="text-sm font-bold text-gray-600 mb-1">
                                                        Codice Non Conformità
                                                    </div>
                                                    <div className="text-base text-gray-900">
                                                        {newMeasureState.savedOldMeasures.filter(om => om.id === ridState.ridUpdateRequest.oldMeasureId)[0]?.code || 'Codice non trovato'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="w-full">
                            <TextArea
                                label="Note"
                                disabled={ridState.getRidByIdResponse?.requestState === RequestStateDTO.CHIUSA}
                                value={ridState.ridUpdateRequest.closedNote}
                                onChangeText={(text) => dispatch(setUpdateRIDClosedNote(text))}
                            />
                        </div>
                    </CustomAccordion>
                )
            }
            <CustomAccordion
                id="panel3"
                title={<span className="text-uppercase text-white label-input">Informazioni Stato di chiusura R.I.D.</span>}
                expanded={expanded === 'panel3'}
                onChange={() => handleToggleAccordion('panel3')}
                detailsClassName="flex flex-col gap-6"
            >
                <div className="grid grid-cols-3 gap-4">
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        label="Modello Ufficio Controllo/S.O.T. - Generica"
                        color="blue"
                        onClick={() => {
                            dispatch(DownloadRidDocx({ id: ridState.ridIdToUpdate, infoType: 'CONTROLLO' }))
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        label="Modello Ufficio Controllo/S.O.T. - Fase di Avvio"
                        color="blue"
                        onClick={() => {
                            dispatch(DownloadRidDocx({ id: ridState.ridIdToUpdate, infoType: 'FASE_DI_AVVIO' }))
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        label="Modello Ufficio Controllo/S.O.T. - Certificazione"
                        color="blue"
                        onClick={() => {
                            dispatch(DownloadRidDocx({ id: ridState.ridIdToUpdate, infoType: 'CERTIFICAZIONE' }))
                        }}
                    />
                </div>
            </CustomAccordion>
            {
                showAlert && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare il R.I.D.?
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(RIDDelete(ridState.ridIdToUpdate))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
        </div>
    )
}